import type { ReactNode } from "react";
import { Link, usePathname, useSearchParams, useUrlState } from "@/app/navigation";
export function PersonLink({ id, children }: { id: string; children: ReactNode }) {
  const { update } = useUrlState();
  const path = usePathname(),
    params = new URLSearchParams(useSearchParams());

  params.set("personId", id);
  params.delete("personTab");
  for (const key of ["companyId", "companyTab", "companyPage"]) params.delete(key);
  params.delete("activityId");
  params.delete("runId");
  return (
    <Link
      href={`${path}?${params}`}
      data-person-id={id}
      onClick={(event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
          return;
        event.preventDefault();
        update({
          personId: id,
          companyId: null,
          companyTab: null,
          companyPage: null,
          person: null,
          personTab: null,
          activityId: null,
          runId: null,
        });
      }}
    >
      {children}
    </Link>
  );
}
